import styled from "styled-components";

export const Container = styled.div`
  padding: ${({ theme }) => theme.spacing * 4}px;
  background-color: ${({ theme }) => theme.colors.shades[0]};
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 450px;
    border-radius: ${({ theme }) => theme.radius}px;
    max-height: 80vh;
    overflow-y: auto;
    height: fit-content;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    /* max-height: unset; */
    /* height: 100%; */
    /* min-height: calc(100% - 30px - 56px); */
    /* overflow-y: auto; */
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    z-index: 2500;
  }
`;

export const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr;
  align-items: center;
  grid-column-gap: ${({ theme }) => theme.spacing * 4}px;
  margin-bottom: ${({ theme }) => theme.spacing * 4}px;
  > h3 {
    margin: 0;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.gray[900]};
  }
`;
